<template>
    <button
        type="button"
        class="od-copy-btn"
        aria-label="Copia"
        title="Copia"
        @click="copy"
    >
        <od-icon :name="copied ? 'check' : 'copy'" :class="{ 'od-copy-btn__ok': copied }" />
    </button>
</template>

<script>
import OdIcon from './OdIcon.vue';

export default {
    name: 'OdCopyButton',
    components: { OdIcon },
    props: {
        value: { type: String, required: true },
    },
    data() {
        return { copied: false };
    },
    methods: {
        copy() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.value).catch(() => {});
            }
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 1200);
        },
    },
};
</script>
